import { render, staticRenderFns } from "./selectInventory.vue?vue&type=template&id=530a2160&scoped=true"
import script from "./selectInventory.vue?vue&type=script&lang=js"
export * from "./selectInventory.vue?vue&type=script&lang=js"
import style0 from "./selectInventory.vue?vue&type=style&index=0&id=530a2160&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "530a2160",
  null
  
)

export default component.exports